import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { injectIntl } from 'react-intl';
import { untouch } from 'redux-form';

import createValidator from 'shared/utils/formValidator';
import {
  getUserGenderOptions,
  getUserTitleOptions,
} from 'modules/appointmentsManagement/selectors/appointments';
import { getCommonUserConfig } from 'modules/user/selectors/users';

import {
  EMPTY_DATE_OF_BIRTH_LOCAL,
  EMPTY_USER_EMAIL_LOCAL,
  EMPTY_USER_LAST_NAME_LOCAL,
  EMPTY_USER_NAME_LOCAL,
  EMPTY_USER_PHONE_LOCAL,
  INVALID_DATE_OF_BIRTH_LOCAL,
  INVALID_EXTERNAL_ID,
  INVALID_FORMAT_USER_EMAIL_LOCAL,
  INVALID_FORMAT_USER_PHONE_LOCAL,
  localErrorMessagesMap,
} from 'modules/user/constants/localErrorCodes';
import {
  EMPTY_SELECT_FIELD,
  EMPTY_TEXT_FIELD,
  localErrorMessagesMap as emptyAuthLocalErrorMessages,
} from 'modules/appointmentsManagement/constants/localErrorCodes';
import { userAttributeLabels } from 'modules/user/constants/userAttributeLabels';

import SecondaryLoginForm from './SecondaryLoginForm';

const form = 'SECONDARY_LOGIN_FORM';

const mapStateToProps = (state, { intl }) => {

  return {
    form,
    userGenderOptions: getUserGenderOptions(intl),
    userTitleOptions: getUserTitleOptions(intl),
    userFieldConfig: getCommonUserConfig(state),
    loginConfig: state.auth.organizations.loginConfig,
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps, { untouch }),
  withHandlers({
    validate: ({ intl, loginConfig = {} }) => (formProps) => {
      const rules = {
        'firstName': ['required', 'string', 'max:200'],
        'lastName': ['required', 'string', 'max:200'],
        'middleName': ['required', 'max:200'],
        'title': ['required'],
        'gender': ['required'],
        'dateOfBirth': ['required', 'dateOfBirth'],
        'type': ['required', 'required'],
        'email': ['required', 'email'],
        'phoneNumber': ['required', `telephone:${ loginConfig.userPhoneCountryCode }`],
        'address': ['required'],
        'description': ['required'],
      };

      return createValidator(rules, {
        'required.firstName': `${ EMPTY_USER_NAME_LOCAL }`,
        'required.middleName': emptyAuthLocalErrorMessages[EMPTY_TEXT_FIELD],
        'required.lastName': `${ EMPTY_USER_LAST_NAME_LOCAL }`,
        'required.title': emptyAuthLocalErrorMessages[EMPTY_SELECT_FIELD],
        'required.gender': emptyAuthLocalErrorMessages[EMPTY_SELECT_FIELD],
        'required.email': `${ EMPTY_USER_EMAIL_LOCAL }`,
        'required.phoneNumber': `${ EMPTY_USER_PHONE_LOCAL }`,
        'required.address': emptyAuthLocalErrorMessages[EMPTY_TEXT_FIELD],
        'required.description': emptyAuthLocalErrorMessages[EMPTY_TEXT_FIELD],
        'required.dateOfBirth': localErrorMessagesMap[EMPTY_DATE_OF_BIRTH_LOCAL],
        'invalid.dateOfBirth': `${ INVALID_DATE_OF_BIRTH_LOCAL }`,
        'invalid.email': `${ INVALID_FORMAT_USER_EMAIL_LOCAL }`,
        'invalid.phoneNumber': `${ INVALID_FORMAT_USER_PHONE_LOCAL }`,
        'regex.externalId': `${ INVALID_EXTERNAL_ID }`,
      }, userAttributeLabels)(formProps, { intl });
    },
  }),
)(SecondaryLoginForm);
